import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import strings from '../../locales/';

class SelectInput extends Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    var endpoint = null
    if(this.props.endpoint!=null && !this.props.readOnly) {
      try {
        endpoint = JSON.parse(this.props.endpoint);
        if(endpoint.length>0) {
          this.props.getOptionsEndpoint(this.props.inputId,endpoint[0]);
        }
      } catch (e) {
        endpoint=null;
      }
    }
  }

  render() {
    var input;
    var readOnly;

    if(this.props.readOnly) {
      input = null;
      readOnly = (
        <p className="formOnlyReadData">{this.props.value}</p>
      );
    }
    else if(this.props.loading) {
      input = null;
      readOnly = (
        <p className="formOnlyReadData yellow">{strings.tasks_manager.taskform["loadingOptions"]}</p>
      );
    }
    else if(this.props.status!=null && this.props.status!=200) {
      input = null;
      readOnly = (
        <p className="formOnlyReadData red">{strings.tasks_manager.taskform["loadingOptionsError"]}</p>
      );
    }
    else if(this.props.options==null) {
      input = null;
      readOnly = null;
    }
    else {
      input = (
        <div className="form-control-wrapper">
          <FormControl 
            componentClass="select"
            id={this.props.inputId}
            name={this.props.inputId}
            value={this.props.value}
            onChange={this.props.handleOnChange}
          >
          {this.props.options.map((option,i) => {
            return (<option selected={(this.props.value==option.key)?true:false} key={i} value={option.key}>{option.value}</option>);
          })}
          </FormControl>
        </div>    
      );
      readOnly = null;
    }

    return (
      <div id={this.props.id} className={this.props.className + (this.props.error ? " invalidInput" :"")}>
        <FormGroup>
          <ControlLabel>
            {this.props.label}
            {(this.props.required && !this.props.readOnly) && (<span className="required">(*)</span>)}
          </ControlLabel>
          {readOnly}     
          {input}
        </FormGroup>
        {this.props.error && (<span className={"required-message"}>{this.props.error}</span>)}
      </div>
    );
  }
}

SelectInput.propTypes = {};

export default SelectInput;



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/selectInput.jsx